<template>
    <board-detail-link :detailLayout="detailLayout" :boardData="boardData"></board-detail-link>
</template>

<script>
    import boardTemplateUtil from "@/components/board/boardTemplateUtil"
    import boardFilterUtil from "@/components/board/boardFilterUtil"
    import EventBus from "@/utils/event-bus";
    import {mapGetters, mapState} from "vuex";
    import BoardDetailLink from "@/components/board/BoardDetailLink";
    import alertMixin from "@/mixins/alertMixin";
    import util from "@/mixins/util";

    export default {
        name: "BoardDetailComponent",
        mixins: [boardTemplateUtil, boardFilterUtil, alertMixin],
        components: {
            BoardDetailLink
        },
        provide() {
            return {}
        },
        props: {
            boardType: {
                type: String,
            },
            boardKey: {
                default :0
            }
        },
        data() {
            return {
                getFunc: null,
                detailLayout: '',
                detailApiParamSet: {},
                boardData: {},
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.initConfig();
            this.getDetail();
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
        },
        methods: {
            initConfig() {
                let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
                this.detailLayout = boardTemplateConfig.detailLayout;
                let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
                this.getFunc = boardFilterConfig.getFunc;

                this.detailApiParamSet = boardFilterConfig.detailApiParamSet;

            },

            getDetail() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet))
                params.id = this.boardKey;
                this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.createAlert({
                            content: '게시글을 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.go(-1);
                            }
                        })
                        return false;
                    }
                    this.boardData = res.List[0];
                })
            },

            setData(key, value) {
                this[key] = value;
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>